import React from "react";
//#region types
import { WintSuperkollAPIModel as ApiModel } from "wint-api-client/dist/types";
import { TranslationKeys } from "translations";
import { ReferencePersonsListProps } from "models/propTypes/customerPropTypes";
import { TableConstants } from "utils/constants";
//#endregion
//#region components
import { TableAsync } from "components/common";
//#endregion

const ReferencePersonsList: React.FC<ReferencePersonsListProps> = (props) => {
  const { contacts, onRowClick } = props;

  return (
    <TableAsync<ApiModel.Reference>
      tableId={TableConstants.CustomerRefernceList}
      rowClickHandler={onRowClick ? (row: ApiModel.Reference) => onRowClick(row) : undefined}
      properties={{
        name: {
          description: TranslationKeys.Common.Name,
          formatter: (r: ApiModel.Reference) => r.name,
          noWrap: true,
        },
        referenceIdentifier: {
          description: TranslationKeys.Customer.RefCode,
          formatter: (r: ApiModel.Reference) => r.referenceIdentifier,
          noWrap: true,
        },
        emailAddress: {
          description: TranslationKeys.Common.Email,
          formatter: (r: ApiModel.Reference) => r.emailAddress,
          noWrap: true,
        },
        phone: {
          description: TranslationKeys.Common.Phone,
          formatter: (r: ApiModel.Reference) => r.phone,
          noWrap: true,
        },
      }}
      filter={contacts ?? []}
      pagination
      maxRowCount={5}
      hidePaginationIfSinglePage
      disableSort
    />
  );
};
export default ReferencePersonsList;
